import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { StateScreen } from '@sauda/ui/kit';
import { Screen } from '../app/chrome.js';
import { LinkButton } from '../app/LinkButton.js';
import { useAuth } from '../auth/AuthContext.js';
import { api } from '../lib/api.js';
import type { BillingOverview } from '../lib/types.js';

const POLL_MS = 2000;
const POLL_FOR_MS = 60_000;

/** Where the gateway sends the owner back to. It waits for the payment event to be applied. */
export function BillingReturnScreen() {
  const { t } = useTranslation();
  const auth = useAuth();
  const started = Date.now();
  const overview = useQuery({
    queryKey: ['billing', auth.agencyId, 'return'],
    queryFn: () => api<BillingOverview>('/billing'),
    refetchInterval: (query) =>
      query.state.data?.subscription.pendingPlanCode === null || Date.now() - started > POLL_FOR_MS
        ? false
        : POLL_MS,
  });
  const settled = overview.data?.subscription.pendingPlanCode === null;
  return (
    <Screen title={t('billing.title')} back="/billing">
      <StateScreen
        kind={settled ? 'success' : 'empty'}
        title={
          overview.data === undefined
            ? t('billing.return.checking')
            : settled
              ? t('billing.return.paid')
              : t('billing.return.pending')
        }
        action={<LinkButton to="/billing">{t('billing.return.open')}</LinkButton>}
      />
    </Screen>
  );
}
